module.exports = __webpack_public_path__ + "static/media/EdmmoSwiss2.f0a4152d.svg";